import type { SsoUser } from '@domain/entities';
import type { IUserRepository } from '@domain/repositories';
import type { InviteUserPayload } from '@application/dto';

/**
 * Alta de usuario: lo crea en el proveedor de identidad y le manda el mail con
 * la clave temporal. No existe alta con clave puesta a mano desde la consola.
 */
export class InviteUserUseCase {
  constructor(private readonly userRepository: IUserRepository) {}

  async execute(payload: InviteUserPayload): Promise<SsoUser> {
    return this.userRepository.invite({
      ...payload,
      email: payload.email.trim().toLowerCase(),
    });
  }
}
